<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <!--      <template slot="menuLeft">-->
      <!--        <el-button-->
      <!--          type="danger"-->
      <!--          size="small"-->
      <!--          icon="el-icon-delete"-->
      <!--          plain-->
      <!--          v-if="permission.ideasbox_delete"-->
      <!--          @click="handleDelete"-->
      <!--          >删 除-->
      <!--        </el-button>-->
      <!--      </template>-->
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload2"
          v-if="permission.ideasbox_edit"
          @click="signIdea(scope.row)"
          :hidden="hideSignBtn(scope.row)"
          >标记
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload2"
          v-if="permission.ideasbox_edit"
          @click="cancelSignIdea(scope.row)"
          :hidden="hideCancelSignBtn(scope.row)"
          >取消标记
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          v-if="permission.ideasbox_edit"
          @click="adoptIdea(scope.row)"
          :hidden="hideAdoptBtn(scope.row)"
          >采纳
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          v-if="permission.ideasbox_edit"
          @click="cancelAdoptIdea(scope.row)"
          :hidden="hideCancelAdoptBtn(scope.row)"
          >取消采纳
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          v-if="permission.ideasbox_edit"
          @click="openResponseIdea(scope.row)"
          >回复
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="反馈意见"
      :visible.sync="openIdeasBoxEditFlag"
      :modal-append-to-body="false"
      @close="quitIdeasBoxEditDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="ideasBoxEditFormRef"
          v-model="ideasBoxEditForm"
          :option="ideasBoxEditOption"
          @submit="ideasBoxEditSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitIdeasBoxEditDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  updateSign,
  updateAdopt,
  updateRead,
  updateCancelSign,
  updateCancelAdopt,
} from '@/api/v4ward/clientserve/ideasbox';
import { mapGetters } from 'vuex';
import ideasBoxEditOption from './ideasbox-edit-option';
import { getCommunityTree } from '../../../api/v4ward/property/baseproperty';
export default {
  data: function () {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      tempCommunityId: '',
      firstDisplayFlag: false,
      communityList: [],
      reWrite: false,
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        indexLabel: '序号',
        searchMenuSpan: 6,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '小区',
            prop: 'communityId',
            type: 'tree',
            dataType: 'string',
            clearable: false,
            dicUrl: '/api/base/property/getCommunityTree',
            props: { label: 'title', value: 'id' },
            search: true,
            rules: [
              {
                required: true,
                message: '请选择小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '小区名称',
            prop: 'communityName',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '标题',
            prop: 'title',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: '阅读状态',
            prop: 'readStatus',
            search: true,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=read_status',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '处理标识',
            prop: 'disposeFlag',
            search: true,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=dispose_flag',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '内容',
            prop: 'content',
            type: 'textarea',
            overHidden: true,
            span: 24,
            row: 4,
          },
          {
            label: '附带图片',
            prop: 'imageUrl',
            type: 'upload',
            width: 200,
            span: 24,
            propsHttp: {
              res: 'data',
              url: 'link',
              name: 'originalName',
            },
            tip: '只能上传不超过5M的文件或图片',
            action: '/api/blade-resource/oss/endpoint/put-file',
            dataType: 'string',
          },
          {
            label: '姓名',
            prop: 'name',
          },
          {
            label: '手机号',
            prop: 'phone',
          },
          {
            label: '住址',
            prop: 'site',
            type: 'textarea',
            overHidden: true,
            span: 24,
            row: 2,
          },
          {
            label: '创建时间',
            prop: 'createTime',
            type: 'date',
            width: 135,
            format: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '回复内容',
            prop: 'response',
            type: 'textarea',
            overHidden: true,
            span: 24,
            row: 4,
          },
        ],
      },
      data: [],
      ideasBoxEditForm: {},
      openIdeasBoxEditFlag: false,
      ideasBoxEditOption: ideasBoxEditOption,
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.ideasbox_add, false),
        viewBtn: this.vaildData(this.permission.ideasbox_view, false),
        delBtn: this.vaildData(this.permission.ideasbox_delete, false),
        editBtn: this.vaildData(this.permission.ideasbox_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //加载列表
    getCommunityTree({}).then((res) => {
      this.communityList = res.data;
      if (this.communityList.length > 0) {
        this.query.communityId = this.communityList[0].id;
        this.tempCommunityId = this.communityList[0].id;
      }
      this.$nextTick(() => {
        this.reWrite = true;
      });
      //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
  },
  methods: {
    quitIdeasBoxEditDialog() {
      this.openIdeasBoxEditFlag = false;
      this.$refs.ideasBoxEditFormRef.resetForm();
    },
    openResponseIdea(row) {
      if (row.readStatus === 1) {
        updateRead(row).then(() => {});
        this.onLoad();
      }
      this.ideasBoxEditForm = row;
      this.openIdeasBoxEditFlag = true;
    },
    ideasBoxEditSubmit(form, done) {
      update(form).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.quitIdeasBoxEditDialog();
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    adoptIdea(row) {
      updateAdopt(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    cancelSignIdea(row) {
      updateCancelSign(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    cancelAdoptIdea(row) {
      updateCancelAdopt(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    signIdea(row) {
      updateSign(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    hideSignBtn(row) {
      return row.disposeFlag === 2;
    },
    hideCancelAdoptBtn(row) {
      return row.disposeFlag === 1 || row.disposeFlag === 2;
    },
    hideCancelSignBtn(row) {
      return row.disposeFlag === 1 || row.disposeFlag === 3;
    },
    hideAdoptBtn(row) {
      return row.disposeFlag === 3;
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          if (data.readStatus === 1) {
            updateRead(data).then(() => {});
            this.onLoad();
          }
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //开启默认搜索第一个小区
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (this.query.communityId == undefined || this.query.communityId == '') {
        this.query.communityId = this.tempCommunityId;
      }
      if (this.query.communityId) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="小区"]');
              ent.value = this.communityList.length > 0 ? this.communityList[0].title : '';
              this.query.communityId =
                this.communityList.length > 0 ? this.communityList[0].id : '';
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          }
        );
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
